import { JobStatus } from '@y42/json-schema';

export enum JobStatusCode {
  Failed = 'Failed',
  Ready = 'Ready',
  Pending = 'Pending',
}

export const JobStatusCodeMap: Record<JobStatus, JobStatusCode> = {
  [JobStatus.New]: JobStatusCode.Pending,
  [JobStatus.Queued]: JobStatusCode.Pending,
  [JobStatus.Pending]: JobStatusCode.Pending,

  [JobStatus.Invalid]: JobStatusCode.Failed,
  [JobStatus.Expired]: JobStatusCode.Failed,
  [JobStatus.Canceled]: JobStatusCode.Failed,

  [JobStatus.InvalidPartial]: JobStatusCode.Failed,
  [JobStatus.PartiallyEmpty]: JobStatusCode.Failed,
  [JobStatus.PartiallyReady]: JobStatusCode.Failed,

  [JobStatus.Ready]: JobStatusCode.Ready,
};

export const JobStatusCodeToStatusMap: Record<JobStatusCode, JobStatus[]> = {
  [JobStatusCode.Ready]: Object.entries(JobStatusCodeMap)
    .filter(([_, value]) => value === JobStatusCode.Ready)
    .map(([key]) => key as JobStatus),
  [JobStatusCode.Failed]: Object.entries(JobStatusCodeMap)
    .filter(([_, value]) => value === JobStatusCode.Failed)
    .map(([key]) => key as JobStatus),
  [JobStatusCode.Pending]: Object.entries(JobStatusCodeMap)
    .filter(([_, value]) => value === JobStatusCode.Pending)
    .map(([key]) => key as JobStatus),
};

export const FinalJobStatuses = [
  JobStatus.Ready,
  JobStatus.Invalid,
  JobStatus.Expired,
  JobStatus.Canceled,
] as Array<`${JobStatus}`>;
